import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { api, apiError, BACKEND_URL } from "../../lib/api";

export function EditedCoverButton({ messageId, cover, onChanged, testKey }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!["image/jpeg", "image/png"].includes(f.type)) return toast.error("Usa un'immagine JPG o PNG");
    if (f.size > 10 * 1024 * 1024) return toast.error("Copertina troppo grande (max 10 MB)");
    const fd = new FormData();
    fd.append("file", f);
    setBusy(true);
    try {
      await api.post(`/staff/messages/${messageId}/edited-cover`, fd);
      toast.success("Copertina salvata: verrà usata quando programmi il video su Metricool");
      onChanged?.();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await api.delete(`/staff/messages/${messageId}/edited-cover`);
      toast.success("Copertina rimossa");
      onChanged?.();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="inline-flex items-center gap-1.5" data-testid={`edited-cover-${testKey}`}>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png" className="hidden" onChange={onPick} data-testid={`edited-cover-input-${testKey}`} />
      {cover?.dropbox_url && (
        <img src={`${BACKEND_URL}${cover.dropbox_url}`} alt="Copertina" className="h-9 w-7 rounded object-cover border border-[var(--mp-ink)]" data-testid={`edited-cover-preview-${testKey}`} />
      )}
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        title="Immagine di copertina per Reel Instagram/Facebook, TikTok e YouTube quando programmi su Metricool. I post già programmati non cambiano."
        className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full border-2 border-[var(--mp-ink)] bg-white text-xs font-medium transition-transform hover:-translate-y-0.5 disabled:opacity-50"
        data-testid={`edited-cover-upload-btn-${testKey}`}
      >
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ImagePlus className="h-3.5 w-3.5" />}
        {cover ? "Cambia copertina" : "Carica copertina"}
      </button>
      {cover && (
        <button type="button" onClick={remove} disabled={busy} title="Rimuovi copertina" className="h-7 w-7 inline-flex items-center justify-center rounded-full hover:bg-black/5" data-testid={`edited-cover-remove-btn-${testKey}`}>
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
